import { Form } from './Form/Form.tsx';
import { type CardFormData } from './Form/Form.types.ts';

export type PaymentByCardFormProps = {
  defaultValue?: Partial<CardFormData>;
  disabledFields?: Partial<Record<keyof CardFormData, boolean>>;
  isCardExisting?: boolean;
  isUnchangeable?: boolean;
};

export const PaymentForm = (props: PaymentByCardFormProps) => {
  const { defaultValue, disabledFields, isCardExisting, isUnchangeable } =
    props;

  return (
    <Form
      defaultValue={defaultValue}
      disabledFields={disabledFields}
      isCardExisting={isCardExisting}
      isUnchangeable={isUnchangeable}
    />
  );
};
